export function isTokenExpired() {
  const token = localStorage.getItem('tokenLogin') || localStorage.getItem('token') || ''
  const expires = localStorage.getItem('expires') || ''
  if (!token || !expires) {
    // 没有 token 或过期时间，说明未登录
    return true
  }

  // 当前时间戳（单位：秒）
  const now = Math.floor(Date.now() / 1000)

  // 如果当前时间 >= 过期时间，则视为已过期
  return now >= parseInt(expires, 10)
}
